// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-list-mote .list-mote, list-mote .list-mote {
  display: flex;
  align-items: top;
  justify-content: left;
  overflow: hidden;
  cursor: pointer;
  max-width: var(--max-width);
}
motes-list-mote .list-mote-img, list-mote .list-mote-img {
  width: 37%;
  max-width: 150px;
  overflow: hidden;
  position: relative;
  border-right: 1px solid white;
  margin-bottom: -5px;
}
motes-list-mote .list-mote-img img, list-mote .list-mote-img img {
  width: 100%;
}
motes-list-mote .list-mote-img svg-icon, list-mote .list-mote-img svg-icon {
  display: none;
  font-size: 50px;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.8;
}
motes-list-mote .list-mote-img.locked svg-icon, list-mote .list-mote-img.locked svg-icon {
  display: initial;
}
motes-list-mote .list-mote-content, list-mote .list-mote-content {
  flex: 1;
  display: flex;
  box-shadow: inset 2px -5px 5px rgba(50, 50, 50, 0.2);
  flex-direction: column;
  min-width: 0;
}
motes-list-mote .list-mote-content p.list-mote-title, list-mote .list-mote-content p.list-mote-title {
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  font-weight: bold;
  text-overflow: ellipsis;
}
motes-list-mote .list-mote-content p.list-mote-preview-text, list-mote .list-mote-content p.list-mote-preview-text {
  color: #555;
  overflow: hidden;
  display: -webkit-box;
  line-height: 120%;
  -webkit-line-clamp: 2;
}
motes-list-mote .list-mote-content .loved, list-mote .list-mote-content .loved {
  color: red;
}
motes-list-mote .list-mote-action-buttons, list-mote .list-mote-action-buttons {
  margin-top: auto;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background: white;
  color: #444;
  text-align: center;
  cursor: pointer;
}
motes-list-mote .list-mote-action-buttons p, list-mote .list-mote-action-buttons p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
motes-list-mote .list-mote-fold-out, list-mote .list-mote-fold-out {
  max-height: 0px;
  transition: 0.3s;
  overflow: hidden;
}
motes-list-mote .list-mote-fold-out .motes-button, list-mote .list-mote-fold-out .motes-button {
  width: 100%;
  margin: 0;
}
motes-list-mote .list-mote-fold-out.list-mote-show-fold-out, list-mote .list-mote-fold-out.list-mote-show-fold-out {
  max-height: 300px;
  transition: 0.3s;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/list-mote/list-mote.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAAR;AAGI;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AADR;AAEQ;EACI,WAAA;AAAZ;AAEQ;EACI,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;AAAZ;AAKQ;EACI,gBAAA;AAHZ;AAOI;EACI,OAAA;EACA,aAAA;EACA,oDAAA;EACA,sBAAA;EACA,YAAA;AALR;AAMQ;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAJZ;AAMQ;EACI,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;AAJZ;AAMQ;EACI,UAAA;AAJZ;AAQI;EACI,gBAAA;EACA,0BAAA;EACA,6BAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AANR;AAQQ;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AANZ;AAUI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AARR;AAUQ;EACI,WAAA;EACA,SAAA;AARZ;AAYI;EACI,iBAAA;EACA,gBAAA;AAVR","sourcesContent":["motes-list-mote, list-mote {\n    .list-mote {\n        display: flex;\n        align-items: top;\n        justify-content: left;\n        overflow: hidden;\n        cursor: pointer;\n        max-width: var(--max-width);\n    }\n\n    .list-mote-img {\n        width: 37%;\n        max-width: 150px;\n        overflow: hidden;\n        position: relative;\n        border-right: 1px solid white;\n        margin-bottom: -5px;    \n        img {\n            width: 100%;\n        }\n        svg-icon {\n            display: none;\n            font-size: 50px;\n            color: white;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            opacity: .8;\n        }\n    }\n\n    .list-mote-img.locked {\n        svg-icon {\n            display: initial;\n        }\n    }\n\n    .list-mote-content {\n        flex: 1;\n        display: flex;\n        box-shadow: inset 2px -5px 5px rgba(50,50,50,.2);\n        flex-direction: column;\n        min-width: 0; // enable truncation: https://css-tricks.com/flexbox-truncated-text/\n        p.list-mote-title {\n            color: inherit;\n            white-space: nowrap;\n            overflow: hidden;\n            font-weight: bold;\n            text-overflow: ellipsis;\n        }\n        p.list-mote-preview-text {\n            color: #555;\n            overflow: hidden;\n            display: -webkit-box;\n            line-height: 120%;\n            -webkit-line-clamp: 2;\n        }\n        .loved {\n            color: red;\n        }\n    }\n\n    .list-mote-action-buttons {\n        margin-top: auto;\n        border-top: 1px solid #ddd;\n        border-bottom: 1px solid #ddd;\n        background: white;\n        color: #444;\n        text-align: center;\n        cursor: pointer;\n\n        p {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n\n    .list-mote-fold-out {\n        max-height: 0px;\n        transition: .3s;\n        overflow: hidden;\n\n        .motes-button {\n            width: 100%;\n            margin: 0;\n        }\n    }\n\n    .list-mote-fold-out.list-mote-show-fold-out {\n        max-height: 300px;\n        transition: .3s;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
